import HttpRequest from './HttpRequest'

class ProportionOfSubjectTypesContactProvider extends HttpRequest {
  findAll (query) {
    return this.get('/proportion-of-subject-types-contact/', query)
  }
}

export default ProportionOfSubjectTypesContactProvider
